import React, { ReactNode } from 'react'
import { ProductVariantPrice } from '@moonpig/web-core-types-graphql'
import { MemberPriceDisplay } from '../MemberPriceDisplay/MemberPriceDisplay'
import { StrikethroughPriceDisplay } from '../StrikethroughPriceDisplay/StrikethroughPriceDisplay'
import { MemberStrikethroughPriceDisplay } from '../MemberStrikethroughPriceDisplay/MemberStrikethroughPriceDisplay'

export const ProductVariantPriceDisplay = ({
  price,
  plusDelivery,
  fallback,
}: {
  price?: ProductVariantPrice
  plusDelivery?: ReactNode
  fallback: ReactNode
}) => {
  switch (price?.__typename) {
    case 'MemberPrice': {
      return <MemberPriceDisplay {...price} plusDelivery={plusDelivery} />
    }
    case 'StrikethroughPrice': {
      return (
        <>
          <StrikethroughPriceDisplay {...price} />
          {plusDelivery}
        </>
      )
    }
    case 'MemberStrikethroughPrice': {
      return (
        <>
          <MemberStrikethroughPriceDisplay {...price} />
          {plusDelivery}
        </>
      )
    }
    default:
      return (
        <>
          {fallback}
          {plusDelivery}
        </>
      )
  }
}
